import { cn } from '@packages/shared/src/utils/cn/cn';
import clsx from 'clsx';
import type { TooltipProps } from './TooltipProps';

const tipTopBottom =
  'before:border-l-color-transparent before:border-r-color-transparent before:scale-y-150 before:border-r-8 before:border-l-8';
const tipAside =
  'before:border-t-color-transparent before:border-b-color-transparent before:scale-x-150 before:border-t-8 before:border-b-8';
const tipTop = 'before:border-b-color-text-light before:-top-1 before:border-b-8';
const tipBottom = 'before:border-t-color-text-light before:-bottom-1 before:border-t-8';
const tipLeftAside = 'before:border-r-color-text-light before:-left-1 before:border-r-8';
const tipRightAside = 'before:border-l-color-text-light before:-right-1 before:border-l-8';
const tipRight = 'before:right-1';
const tipLeft = 'before:left-1';

const toolTipBottomRight = cn('mt-4', tipTop, tipLeft, tipTopBottom);
const toolTipBottomLeft = cn('mt-4', tipTop, tipRight, tipTopBottom);
const toolTipTopRight = cn('bottom-0 mb-4.5', tipBottom, tipLeft, tipTopBottom);
const toolTipTopLeft = cn('bottom-0 mb-4.5', tipBottom, tipRight, tipTopBottom);
const toolTipRight = cn('left-4 -mt-1', tipLeftAside, tipAside);
const toolTipLeft = cn('right-4 -mt-1', tipRightAside, tipAside);

export const toolTipStyles = {
  toolTipBottomRight,
  toolTipBottomLeft,
  toolTipTopRight,
  toolTipTopLeft,
  toolTipRight,
  toolTipLeft,
};

export const infoIconStyles = ({
  variant,
  positioningInfoIcon,
  positioningTooltip,
}: {
  variant?: 'inline' | 'default';
  positioningInfoIcon: TooltipProps['positioning'];
  positioningTooltip?: TooltipProps['positioning'];
}) =>
  clsx(
    'text-size-h4 flex flex-col p-0.5',
    variant === 'inline' ? 'relative' : 'absolute',
    positioningInfoIcon === 'left' && 'top-1/2 left-1',
    positioningInfoIcon === 'right' && 'top-1/2 right-1',
    positioningInfoIcon === 'top-start' && 'top-1 left-1',
    positioningInfoIcon === 'top-end' && 'top-1 right-1',
    positioningInfoIcon === 'bottom-start' && 'bottom-1 left-1',
    positioningInfoIcon === 'bottom-end' && 'right-1 bottom-1',
    positioningTooltip &&
      ['right', 'top-end', 'bottom-end'].includes(positioningTooltip) &&
      'items-end',
  );

export const wrapperStyles = ({
  variant,
  positioning,
}: {
  variant?: TooltipProps['variant'];
  positioning: TooltipProps['positioning'];
}) =>
  clsx(
    variant === 'inline' ? 'inline-flex' : 'flex',
    positioning &&
      ['top-start', 'bottom-start', 'left'].includes(positioning) &&
      'flex-row-reverse',
    'relative',
  );

export const infoIconButtonStyles = (tooltipOpen: boolean) =>
  clsx(
    'bg-color-info-light border-color-info-dark hover:bg-color-info! h-3 min-h-3 w-3 border-1 border-solid',
    tooltipOpen && 'shadow-lg',
  );

export const tooltipContainerStyles = (positioningTooltip?: TooltipProps['positioning']) =>
  clsx(
    'z-tooltip text-size-body3 bg-color-text-light text-color-text-dark absolute m-0.5 w-[18.75rem] max-w-[70vw] rounded p-1 font-normal shadow-lg before:absolute',
    positioningTooltip === 'top-start' && toolTipStyles.toolTipBottomRight,
    positioningTooltip === 'top-end' && toolTipStyles.toolTipBottomLeft,
    positioningTooltip === 'left' && toolTipStyles.toolTipRight,
    positioningTooltip === 'right' && toolTipStyles.toolTipLeft,
    positioningTooltip === 'bottom-start' && toolTipStyles.toolTipTopRight,
    positioningTooltip === 'bottom-end' && toolTipStyles.toolTipTopLeft,
  );
